<img width="{{ height - 5 }}" class="mb-1" src="../../../assets/icons/spinner.gif">
